import { render, staticRenderFns } from "./IabBillingModal.vue?vue&type=template&id=59f5cf7c&"
import script from "./IabBillingModal.vue?vue&type=script&lang=js&"
export * from "./IabBillingModal.vue?vue&type=script&lang=js&"
import style0 from "./IabBillingModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports